import { createFileRoute } from '@tanstack/react-router';

import { CAPABILITY_KEYS } from '@brightlocal/shared';

import { requireCustomerCapability } from 'shared/modules/capabilities';
import { routes } from 'shared/routes';

import { AddPrompts } from 'features/get-started/AddPrompts';

export const Route = createFileRoute('/_authenticated/get-started/_get-started/add-prompts/')({
  beforeLoad: ({ context, location }) =>
    requireCustomerCapability({
      queryClient: context.queryClient,
      key: CAPABILITY_KEYS.AI_VISIBILITY,
      fallbackRoute: routes.gettingInsights(),
      attemptedHref: location.href
    }),
  component: AddPromptsRoute
});

function AddPromptsRoute() {
  return <AddPrompts />;
}
